// extracted by mini-css-extract-plugin
export default {"mobileHeight":"screen and (max-height: 824px)","container":"Lock_container__GMpCv","iconContainer":"Lock_iconContainer__C7QcL"};